export class IdGenerationUtils {
    private static _idCounter = 0;
    public static generateUniqueId(): number {
        return ++IdGenerationUtils._idCounter;
    }
}
